function buildFileData(courseSectionGUID, studentRID, accessToken, clientID, data) {
	return {
		"fileObject": true,
		"size": data.SIZE,
		"name": data.NAME,
		"type": "",
		"active": false,
		"error": "",
		"success": true,
		"putAction": "__vue_devtool_undefined__",
		"postAction": `/PortalAPI/index.cfm/api/v1/class-pages/${courseSectionGUID}/files?student_rid=${studentRID}`,
		"timeout": 0,
		"file": "{}",
		"response": {
			"data": {
				"HASHB": data.HASHB,
				"COLLISION_ID": data.COLLISION_ID,
				"HASHA": data.HASHA,
				"SIZE": data.SIZE,
				"TYPE": data.TYPE,
				"NAME": data.NAME
			},
			"messages": [],
			"error": false
		},
		"progress": "100.00",
		"speed": 0,
		"data": {},
		"headers": {
			"Authorization": `bearer ${accessToken}`,
			"Client-ID": clientID
		},
		"id": "",
		"xhr": ""
	};
}

export { buildFileData };
